import { render, staticRenderFns } from "./TagList.vue?vue&type=template&id=2e5709a2&scoped=true&"
import script from "./TagList.vue?vue&type=script&lang=js&"
export * from "./TagList.vue?vue&type=script&lang=js&"
import style0 from "./TagList.vue?vue&type=style&index=0&id=2e5709a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5709a2",
  null
  
)

export default component.exports